import { Injectable } from "@angular/core";
import { ProductionsApi, ApiProduction } from "@tytapp/api";
import { Cache, PagedArray } from "@tytapp/common";

@Injectable()
export class ProductionsService {
    constructor(
        private productionsApi: ProductionsApi
    ) {
    }

    cache: Cache<ApiProduction> = Cache.shared<ApiProduction>('productions', 1000 * 60 * 15, 100);
    feedCache: Cache<PagedArray<ApiProduction>> = Cache.shared<PagedArray<ApiProduction>>('production-feeds', 1000 * 60 * 15, 20);

    async latestProductionByHost(hostID: string, offset?, limit?) {
        return this.feedCache.fetch(`host-${hostID}-page-${offset}-${limit}`, async skip => {
            return await this.productionsApi.getLatestProductionByHost(hostID, offset, limit).toPromise();
        });
    }

    async latestPodcasts(offset?, limit?) {
        return await this.feedCache.fetch(`podcasts-page-${offset}-${limit}`, async skip => {
            return await this.productionsApi.getLatestPodcasts(offset, limit).toPromise() as PagedArray<ApiProduction>;
        });
    }

    async latestVODs(offset?, limit?) {
        return await this.feedCache.fetch(`vods-page-${offset}-${limit}`, async skip => {
            return await this.productionsApi.getLatestVODs(offset, limit).toPromise() as PagedArray<ApiProduction>;
        });
    }

    async latestClips(offset?, limit?) {
        return await this.feedCache.fetch(`clips-page-${offset}-${limit}`, async skip => {
            return await this.productionsApi.getLatestClips(offset, limit).toPromise() as PagedArray<ApiProduction>;
        });
    }

    async latestCandidates(offset?, limit?) {
        return await this.feedCache.fetch(`candidates-page-${offset}-${limit}`, async skip => {
            return await this.productionsApi.getCandidateVODs(offset, limit).toPromise() as PagedArray<ApiProduction>;
        });
    }

    async get(id: string) {
        // No caching here until we can reliably test entitlement from app-server-side
        return await this.productionsApi.get(id).toPromise() as ApiProduction;
    }
}